module.exports = __webpack_public_path__ + "static/media/composition-inbody.50ce8de3.png";